/** Apollo RestLink exposes an HTTP rejection on networkError.statusCode. */
export const campaignRequestErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  const status = (error as { networkError?: { statusCode?: number } } | null)
    ?.networkError?.statusCode;

  return status === 409
    ? 'Another request for this campaign is still running. Please wait for it to finish before trying again.'
    : fallback;
};
